import { render, staticRenderFns } from "./ITApproval.vue?vue&type=template&id=009925d8&scoped=true"
import script from "./ITApproval.vue?vue&type=script&lang=js"
export * from "./ITApproval.vue?vue&type=script&lang=js"
import style0 from "./ITApproval.vue?vue&type=style&index=0&id=009925d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009925d8",
  null
  
)

export default component.exports